export const SUBSCRIPTION_COLUMNS = [
  { key: 'active', label: 'Active', color: '#10b981' },
  { key: 'at_risk', label: 'At Risk', color: '#f59e0b' },
  { key: 'critical', label: 'Critical', color: '#ef4444' },
  { key: 'paused', label: 'Paused', color: '#64748b' },
  { key: 'churned', label: 'Churned', color: '#94a3b8' }
];
